import search from '@finn-no/frontpage-search';

export default {
    dependencies: ['$element', 'sitesettings'],
    callable(form, sitesettings) {
        const STREAMING_SUGGEST_URL =
            sitesettings.wwwSite +
            sitesettings.streamingSuggestFrontPageEndPoint;
        const SUGGEST_URL =
            sitesettings.wwwSite + sitesettings.suggestFrontPageEndPoint;

        return search(form, STREAMING_SUGGEST_URL, SUGGEST_URL, 'MFINN');
    },
};



// WEBPACK FOOTER //
// ./controllers/searchFrontSuggest.js